import React, { useContext, useState } from 'react'
import { Card, Button, Form, Row, Col, Container } from 'react-bootstrap'
import axios from 'axios'
import { useParams } from 'react-router-dom'
import { AuthContext } from '../../AuthContext'
import Cookies from 'js-cookie'

// 定義選項常數
const QUALITY_OPTIONS = [
  { value: 0, label: '很好' },
  { value: 1, label: '普通' },
  { value: 2, label: '不好' },
  { value: 3, label: '非常差' },
]

const FEELING_OPTIONS = [
  { value: 0, label: '精神飽滿' },
  { value: 1, label: '心情愉快' },
  { value: 2, label: '頭昏腦脹' },
  { value: 3, label: '想賴床' },
  { value: 4, label: '身體酸痛疲勞' },
]

const SPEED_OPTIONS = [
  { value: 0, label: '很快就睡著' },
  { value: 1, label: '躺一陣子才睡著' },
  { value: 2, label: '輾轉反側難入睡' },
]

const AddSleep = ({ onSuccess, onCancel, date }) => {
  const { patient_id } = useParams()
  const { baseUrl, currentUser, extendCookie, setLoginShow } =
    useContext(AuthContext)
  const sessionFromCookie = Cookies.get('session')
  const { session = '' } = sessionFromCookie
    ? JSON.parse(sessionFromCookie)
    : {}

  // Update the initial records state to include default times
  const getDefaultEndTime = () => {
    // Create dates for current day and next day
    const currentDate = new Date(date)
    const nextDate = new Date(date)
    nextDate.setDate(nextDate.getDate() + 1)

    // Format the next day's date
    const nextDay = nextDate.toISOString().split('T')[0]

    return {
      defaultStart: '23:00', // Default start time at 23:00
      defaultEnd: '06:30', // Default end time at 06:30
      nextDay: nextDay, // Store next day's date for submission
    }
  }

  // const getNextDay = (currentDate) => {
  //   const nextDate = new Date(currentDate)
  //   nextDate.setDate(nextDate.getDate() + 1)
  //   return nextDate.toISOString().split('T')[0]
  // }

  const getPreviousDay = (currentDate) => {
    const prevDate = new Date(currentDate)
    prevDate.setDate(prevDate.getDate() - 1)
    return prevDate.toISOString().split('T')[0]
  }

  // Format date for display (e.g., "11/27")
  const formatDisplayDate = (dateString) => {
    const date = new Date(dateString)
    return `${date.getMonth() + 1}/${date.getDate()}`
  }

  // 初始化記錄狀態
  const [records, setRecords] = useState([
    {
      startTime: '',
      endTime: '',
      quality: '',
      feeling: [], // 多選，所以用陣列
      speed: '',
      comment: '',
    },
  ])

  const [isSubmitting, setIsSubmitting] = useState(false)
  const [errors, setErrors] = useState({})

  // 添加新的一筆記錄欄位
  const handleAddNewRow = () => {
    // const defaultTimes = getDefaultEndTime()
    setRecords((prev) => [
      ...prev,
      {
        startTime: '',
        endTime: '',
        quality: '',
        feeling: [],
        speed: '',
        comment: '',
      },
    ])
  }

  // 處理輸入變更（一般欄位）
  const handleInputChange = (index, field, value) => {
    setRecords((prev) =>
      prev.map((record, i) =>
        i === index ? { ...record, [field]: value } : record
      )
    )

    // 清除該欄位的錯誤訊息
    if (errors[`${field}_${index}`]) {
      setErrors((prev) => {
        const newErrors = { ...prev }
        delete newErrors[`${field}_${index}`]
        return newErrors
      })
    }
  }

  // 處理多選感受的變更
  const handleFeelingChange = (index, value) => {
    setRecords((prev) =>
      prev.map((record, i) => {
        if (i !== index) return record

        // 如果已經選了這個選項，就移除它；否則加入它
        const newFeeling = record.feeling.includes(value)
          ? record.feeling.filter((f) => f !== value)
          : [...record.feeling, value]

        return { ...record, feeling: newFeeling }
      })
    )

    // 清除錯誤訊息
    if (errors[`feeling_${index}`]) {
      setErrors((prev) => {
        const newErrors = { ...prev }
        delete newErrors[`feeling_${index}`]
        return newErrors
      })
    }
  }

  // 驗證表單
  const validateForm = () => {
    const newErrors = {}
    let isValid = true

    records.forEach((record, index) => {
      // 檢查開始時間
      if (!record.startTime) {
        newErrors[`startTime_${index}`] = '請輸入開始時間'
        isValid = false
      }

      // 檢查結束時間
      if (!record.endTime) {
        newErrors[`endTime_${index}`] = '請輸入結束時間'
        isValid = false
      }

      // 檢查時間順序（考慮跨日情況）
      if (record.startTime && record.endTime) {
        const start = new Date(`${getPreviousDay(date)} ${record.startTime}`)
        const end = new Date(`${date} ${record.endTime}`)

        // 如果結束時間小於開始時間，假設是跨日，將結束時間加一天
        if (end < start) {
          end.setDate(end.getDate() + 1)
        }

        // 檢查持續時間是否合理（比如不超過24小時）
        const duration = (end - start) / (1000 * 60 * 60) // 轉換為小時
        if (duration > 24) {
          newErrors[`time_${index}`] = '睡眠時間不能超過24小時'
          isValid = false
        }
      }

      // 檢查睡眠品質
      if (record.quality === '') {
        newErrors[`quality_${index}`] = '請選擇睡眠品質'
        isValid = false
      }

      // 檢查睡醒感受（至少選擇一項）
      if (record.feeling.length === 0) {
        newErrors[`feeling_${index}`] = '請至少選擇一個睡醒感受'
        isValid = false
      }

      // 檢查入睡速度
      if (record.speed === '') {
        newErrors[`speed_${index}`] = '請選擇入睡速度'
        isValid = false
      }
    })

    setErrors(newErrors)
    return isValid
  }

  // 提交新記錄
  const handleSubmit = async () => {
    if (!session) {
      setLoginShow(true)
      return
    }

    if (!validateForm()) return

    try {
      setIsSubmitting(true)
      // const nextDay = getDefaultEndTime().nextDay
      const previousDay = getPreviousDay(date)

      // 格式化數據
      const sleep = records.map((record) => {
        // const startHour = parseInt(record.startTime.split(':')[0])
        // const endHour = parseInt(record.endTime.split(':')[0])
        // const endDate = endHour < startHour ? nextDay : date

        return {
          quality: parseInt(record.quality),
          feeling: record.feeling.map((f) => parseInt(f)),
          speed: parseInt(record.speed),
          start_time: `${previousDay} ${record.startTime}:00`,
          end_time: `${date} ${record.endTime}:00`,
          comment: record.comment || '',
        }
      })

      const response = await axios.post(
        `${baseUrl}/api/crm/patient/measure/addSleep`,
        {
          patient_id,
          sleep,
        },
        {
          headers: {
            'Content-Type': 'application/json',
            Accept: '*/*',
            session: currentUser?.session || session || '',
          },
        }
      )

      if (response.data.message === '新增成功') {
        onSuccess?.()
        extendCookie()
      }
    } catch (error) {
      console.error('Error adding sleep records:', error)
      if (error.response?.data?.error?.code === '50004') {
        setLoginShow(true)
      } else {
        setErrors({ submit: '新增記錄失敗，請稍後再試' })
      }
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <Container className="py-4">
      <div className="mb-4">
        <Button
          variant="link"
          onClick={onCancel}
          className="text-decoration-none text-secondary"
        >
          <h5>
            <i className="fa-solid fa-arrow-left me-2" />
            返回數據收集紀錄
          </h5>
        </Button>
      </div>

      <Card className="position-relative mb-4 rounded-3 p-4">
        {/* 日期和按鈕區域 */}
        <div className="d-flex justify-content-between align-items-center">
          <h4 className="m-0">{date}</h4>
          <div>
            <Button
              variant="outline-primary"
              className="me-2"
              onClick={onCancel}
              disabled={isSubmitting}
            >
              取消
            </Button>
            <Button
              variant="primary"
              onClick={handleSubmit}
              disabled={isSubmitting}
            >
              {isSubmitting ? '儲存中...' : '儲存'}
            </Button>
          </div>
        </div>

        {/* 記錄輸入區域 */}
        {records.map((record, index) => (
          <div key={index} className="mt-4 p-3">
            <Row className="g-3 justify-content-center align-items-center">
              {/* 時間選擇 */}
              <Col>
                <Form.Group>
                  <Form.Label>
                    開始時間 ({formatDisplayDate(getPreviousDay(date))})
                  </Form.Label>
                  <Form.Control
                    type="time"
                    value={record.startTime}
                    onChange={(e) =>
                      handleInputChange(index, 'startTime', e.target.value)
                    }
                    isInvalid={
                      !!errors[`startTime_${index}`] ||
                      !!errors[`time_${index}`]
                    }
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors[`startTime_${index}`] || errors[`time_${index}`]}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>{' '}
              ～{' '}
              <Col>
                <Form.Group>
                  <Form.Label>結束時間 ({formatDisplayDate(date)})</Form.Label>
                  <Form.Control
                    type="time"
                    value={record.endTime}
                    onChange={(e) =>
                      handleInputChange(index, 'endTime', e.target.value)
                    }
                    isInvalid={!!errors[`endTime_${index}`]}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors[`endTime_${index}`]}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              {/* 睡眠品質 */}
              <Col md={3}>
                <Form.Group>
                  {/* <Form.Label>睡眠品質</Form.Label> */}
                  <Form.Select
                    value={record.quality}
                    onChange={(e) =>
                      handleInputChange(index, 'quality', e.target.value)
                    }
                    isInvalid={!!errors[`quality_${index}`]}
                  >
                    <option value="">選擇睡眠品質</option>
                    {QUALITY_OPTIONS.map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">
                    {errors[`quality_${index}`]}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              {/* 入睡速度 */}
              <Col md={3}>
                <Form.Group>
                  {/* <Form.Label>入睡速度</Form.Label> */}
                  <Form.Select
                    value={record.speed}
                    onChange={(e) =>
                      handleInputChange(index, 'speed', e.target.value)
                    }
                    isInvalid={!!errors[`speed_${index}`]}
                  >
                    <option value="">選擇入睡速度</option>
                    {SPEED_OPTIONS.map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">
                    {errors[`speed_${index}`]}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            <Row className="mt-3 justify-content-center align-items-center">
              {/* 睡醒感受（多選） */}
              <Col md={6}>
                <Form.Group>
                  <Form.Label>起床感受（可複選）</Form.Label>
                  <div className="d-flex flex-wrap gap-2 h6">
                    {FEELING_OPTIONS.map((option) => (
                      <Form.Check
                        key={option.value}
                        type="checkbox"
                        id={`feeling-${index}-${option.value}`}
                        label={option.label}
                        checked={record.feeling.includes(String(option.value))}
                        onChange={() =>
                          handleFeelingChange(index, String(option.value))
                        }
                        isInvalid={!!errors[`feeling_${index}`]}
                      />
                    ))}
                  </div>
                  {errors[`feeling_${index}`] && (
                    <div className="text-danger small mt-1">
                      {errors[`feeling_${index}`]}
                    </div>
                  )}
                </Form.Group>
              </Col>
              {/* 備註 */}
              <Col md={6}>
                <Form.Group>
                  {/* <Form.Label>備註</Form.Label> */}
                  <Form.Control
                    placeholder="備註可留空"
                    value={record.comment}
                    onChange={(e) =>
                      handleInputChange(index, 'comment', e.target.value)
                    }
                  />
                </Form.Group>
              </Col>
            </Row>
          </div>
        ))}

        {/* 新增一筆按鈕 */}
        <div className="d-flex justify-content-center mt-3">
          <Button
            variant="primary"
            className="text-white text-decoration-none"
            onClick={handleAddNewRow}
            disabled={isSubmitting}
          >
            + 新增一筆
          </Button>
        </div>
      </Card>

      {errors.submit && (
        <div className="text-danger text-center mt-2">{errors.submit}</div>
      )}
    </Container>
  )
}

export default AddSleep
